<template>
  <van-swipe :autoplay="3000" lazy-render :style='{
    margin: HNewGameUIConfig.newGameUIType === 4?"6px 6px 0 6px":HNewGameUIConfig.newGameUIType === 0?"0 10px":"0",
    borderRadius: noRadius ? "0" : (HNewGameUIConfig.newGameUIType === 4?"10px":HNewGameUIConfig.newGameUIType === 0?"4px":"0"),
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    paddingBottom: indicatorBelow ? "20px" : "",
  }'>
    <van-swipe-item v-for="eachData in (data.length<=0?tempData:data)" @click="clickBanner(eachData)"
                    :key="eachData['Icon']">
      <HCacheImage :src="eachData['Icon']" :height="height??'100%'" :width="width??'100%'"/>
    </van-swipe-item>
    <template v-if="data.length>1" #indicator="{ active, total }">
      <div class="custom-indicator" :style="{bottom: indicatorBelow ? '6px' : '5px'}">
        <div :style="indicatorBelow
              ? {display:'flex',justifyContent:'center',alignItems:'center'}
              : {backgroundColor:'#0003',padding:'5px',borderRadius:'10px',display:'flex',justifyContent:'center',alignItems:'center'}">
          <div v-for="num in total" :key="num"
               :class="['eachIndicator', num-1 === active?(HNewGameUIConfig.newGameUIType === 0?'eachIndicatorActiveMain':'eachIndicatorActiveOther'):'']"/>
        </div>
      </div>
    </template>
  </van-swipe>
</template>


<script setup>
  import HCacheImage from "@/components/utils/HCacheImage.vue";
  import {useClickModal} from "@/hooks/useClickModal.js";
  import {hdi} from "@/components/utils/HDeviceInfo.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";

  let tempData = ["https://"];
  const props = defineProps(["data", "height", "width", "indicatorBelow", "noRadius"]);
  const emit = defineEmits(["itemClick"]);
  const clickModal = useClickModal();

  function clickBanner(eachBannerData) {
    clickModal.onClick(eachBannerData["ClickItem"]);
    emit("itemClick", eachBannerData);
  }

</script>


<style scoped>
  .custom-indicator {
    display: flex;
    flex-direction: row;
    position: absolute;
    right: 0;
    bottom: 5px;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 2px 5px;
    font-size: 12px;
  }

  .eachIndicator {
    width: 4px;
    height: 4px;
    margin-right: 5px;
    border-radius: 20px;
    background-color: #ccc
  }

  .eachIndicatorActiveMain {
    width: 15px;
    background-color: #ffae00;
  }

  .eachIndicatorActiveOther {
    width: 15px;
    background-color: var(--ct-main-color);
  }
</style>
